import React, { useState } from "react";

import { Tooltip } from "@mui/material";
import { Popover } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { Button } from "Components/Form";
import { Color } from "Components/Form/Button";
import Checkbox from "Components/Form/Checkbox";
import TableOutlineFilterButton from "Components/Form/TableOutlineFilterButton/TableOutlineFilterButton";
import { useTranslation } from "react-i18next";

const imageClose = require("Assets/img/close-icon.svg");

interface Props {
  typeOptions: string[];
  statusOptions: string[];
  onFilter: (value: any) => void;
  checkedType?: Record<string, boolean> | any;
  checkedStatus?: Record<string, boolean> | any;
  countChecked?: number;
}
const SelectFilterOrderComponent = (props?: Props) => {
  const { t: translate } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const id = anchorEl ? "simple-popover" : undefined;
  const [internalCheckedType, setInternalCheckedType] = useState<Record<string, boolean>>(
    props?.checkedType
  );
  const [internalCheckedStatus, setInternalCheckedStatus] = useState<Record<string, boolean>>(
    props?.checkedStatus
  );
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCheckboxTypeChange = (value: string, checked: boolean) => {
    setInternalCheckedType((prev) => ({
      ...prev,
      [value]: checked,
    }));
  };
  const handleCheckboxStatusChange = (value: string, checked: boolean) => {
    setInternalCheckedStatus((prev) => ({
      ...prev,
      [value]: checked,
    }));
  };

  const handleClearAll = () => {
    setInternalCheckedType({});
    setInternalCheckedStatus({});
  };

  const handleClose = () => {
    setAnchorEl(null);
    setInternalCheckedType(props?.checkedType);
    setInternalCheckedStatus(props?.checkedStatus);
  };

  const onSubmit = () => {
    props?.onFilter({
      type: Object.fromEntries(
        Object.entries(internalCheckedType).filter(([_, value]) => value === true)
      ),
      status: Object.fromEntries(
        Object.entries(internalCheckedStatus).filter(([_, value]) => value === true)
      ),
    });
    setAnchorEl(null);
  };

  return (
    <>
      <TableOutlineFilterButton
        onClickHandler={handleClick}
        label={translate("filters")}
        tooltip={translate("filters")}
        countNumber={props?.countChecked || 0}
      />
      {anchorEl && (
        <Popover
          id={id}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          sx={{
            "& .MuiPaper-elevation8": {
              boxShadow:
                "0px 2px 6px 2px rgba(71, 84, 103, 0.15), 0px 1px 2px 0px rgba(71, 84, 103, 0.30)",
            },
            "& .MuiPaper-rounded": {
              borderRadius: "12px",
            },
          }}
        >
          <div
            style={{
              width: "375px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  color: colors.gray600,
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "20px",
                  fontStyle: "normal",
                }}
              >
                {" "}
                {translate("filters")}
              </div>
              <img
                onClick={handleClose}
                src={imageClose}
                style={{
                  cursor: "pointer",
                }}
              />
            </div>
            <div
              style={{
                width: "100%",
                borderRadius: "8px",
                background: colors.gray25,
                display: "flex",
                border: `1px solid ${colors.gray200}`,
                height: "200px",
                maxHeight: "250px",
                overflow: "auto",
              }}
            >
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "8px",
                  flex: "1 0 0",
                  padding: "12px",

                  borderRight: `1px solid ${colors.gray200}`,
                }}
              >
                <div
                  style={{
                    color: colors.gray700,
                    fontSize: "10px",
                    fontWeight: 700,
                    lineHeight: "15px",
                    fontFamily: "Manrope",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    fontStyle: "normal",
                  }}
                >
                  {translate("type")}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  {" "}
                  {props?.typeOptions?.map((item: string) => {
                    return (
                      <>
                        <div
                          style={{
                            gap: "6px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            checked={internalCheckedType[item] || false}
                            onChange={(e) => handleCheckboxTypeChange(item, e.target.checked)}
                          />
                          <div
                            style={{
                              color: "#667085",
                              fontFamily: "Manrope",
                              fontSize: "10px",
                              fontStyle: "normal",
                              fontWeight: "400",
                              lineHeight: "16px",
                            }}
                          >
                            {item}
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "12px",

                  gap: "8px",
                  flex: "1 0 0",
                }}
              >
                <div
                  style={{
                    color: colors.gray700,
                    fontSize: "10px",
                    fontWeight: 700,
                    lineHeight: "15px",
                    fontFamily: "Manrope",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    fontStyle: "normal",
                  }}
                >
                  {translate("status")}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  {" "}
                  {props?.statusOptions?.map((item: string) => {
                    return (
                      <>
                        <div
                          style={{
                            gap: "6px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            checked={internalCheckedStatus[item] || false}
                            onChange={(e) => handleCheckboxStatusChange(item, e.target.checked)}
                          />
                          <div
                            style={{
                              color: "#667085",
                              fontFamily: "Manrope",
                              fontSize: "10px",
                              fontStyle: "normal",
                              fontWeight: "400",
                              lineHeight: "16px",
                            }}
                          >
                            {item}
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Tooltip title={translate("common.clearAll")}>
                <div>
                  <Button
                    disabled={
                      !Object?.values(internalCheckedType)?.some((value) => value) &&
                      !Object?.values(internalCheckedStatus)?.some((value) => value)
                    }
                    customColor={Color.SECONDARY_DARK_OUTLINED}
                    onClick={() => {
                      handleClearAll();
                    }}
                  >
                    {translate("common.clearAll")}
                  </Button>
                </div>
              </Tooltip>
              <Tooltip title={translate("apply")}>
                <div>
                  <Button
                    customColor={Color.SECONDARY_DARK}
                    onClick={() => {
                      onSubmit();
                    }}
                  >
                    {translate("apply")}
                  </Button>
                </div>
              </Tooltip>
            </div>
          </div>
        </Popover>
      )}
    </>
  );
};

export default SelectFilterOrderComponent;
